export enum IdleResponse {
  Logout,
  Stay
}
